export const RESET = 'RESET';

export const START = 'START';

export const INITIALISE_URL_QUERY_DATA = 'INITIALISE_URL_QUERY_DATA';

export const UPDATE_PERSON_ATTRIBUTE = 'UPDATE_PERSON_ATTRIBUTE';

export const CREATE_MESSAGE = 'CREATE_MESSAGE';

export const SUBMIT_SUCCESS = 'SUBMIT_SUCCESS';
export const SUBMIT_ERROR = 'SUBMIT_ERROR';

export const SUBMIT_NEWSLETTER_SUCCESS = 'SUBMIT_NEWSLETTER_SUCCESS';



// WEBPACK FOOTER //
// ./src/constants/actions/DefaultActionTypes.js